import { createMixpanelAnalyticsClient } from '@satellite/analytics/createMixpanelAnalyticsClient';
import type { AnalyticsClient } from '@satellite/composables/useAnalytics';
import config from '@/config';

/**
 * Builds the Mixpanel client Juno provides through `analyticsKey`.
 *
 * No Session Replay: the check-out flow is a public, unauthenticated funnel, so there is no
 * org type for the gate to sample on.
 */
export function createJunoAnalyticsClient(): AnalyticsClient {
  return createMixpanelAnalyticsClient({
    token: config.mixpanel_token,
    serverEnv: config.server_env
  });
}
